import { Home, Circle , ShoppingCart, Package} from 'react-feather'

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  {
    id: 'supplier',
    title: 'Fornecedor',
    icon: <Package size={20} />,
    children: [
      {
        id: 'Cotations',
        title: 'Cotações',
        icon: <Circle size={20} />,
        navLink: '/supplier/cotations',
        action: 'true',
        resource: 'supplier_navigation'
      },
      {
        id: 'Orders',
        title: 'Orders',
        icon: <Circle size={12} />,
        navLink: '/supplier/orders' , 
        action: 'true',
        resource: 'supplier_navigation'
      },
      {
        id: 'PurchaseOrders',
        title: 'Pedidos de compra',
        icon: <Circle size={12} />,
        navLink: '/supplier/purchase-orders' , 
        action: 'true',
        resource: 'supplier_navigation'
      }
    ]
  }
]
